/**
 * Service Templates Index
 *
 * Aggregates all service templates from individual service files
 */

import { hubspotTemplate } from './hubspot.js'
import { salesforceTemplate } from './salesforce.js'
import { mailchimpTemplate } from './mailchimp.js'
import { shopifyTemplate } from './shopify.js'
import { marketoTemplate } from './marketo.js'
import { slackTemplate } from './slack.js'
import { zendeskTemplate } from './zendesk.js'
import { adobeMarketingTemplate } from './adobe-marketing.js'
import { brazeTemplate } from './braze.js'
import { klaviyoTemplate } from './klaviyo.js'
import { activecampaignTemplate } from './activecampaign.js'
import { segmentTemplate } from './segment.js'
import { onesignalTemplate } from './onesignal.js'

/**
 * All system integration templates aggregated from individual service files
 */
export const SYSTEM_TEMPLATES = [
	hubspotTemplate,
	salesforceTemplate,
	mailchimpTemplate,
	shopifyTemplate,
	marketoTemplate,
	slackTemplate,
	zendeskTemplate,
	adobeMarketingTemplate,
	brazeTemplate,
	klaviyoTemplate,
	activecampaignTemplate,
	segmentTemplate,
	onesignalTemplate
]

export default SYSTEM_TEMPLATES
